<template>
  <FDropdown
    :items="displayYearOptions"
    :value="value"
    :disabled="disabled"
    :hideClear="hideClear"
    @input="(v) => $emit('input', v)"
  />
</template>

<script>
import { getProductRateYearList } from "@/config/productRateYears";
import FDropdown from "../items/FDropdown";

export default {
  props: {
    value: String,
    disabled: Boolean,
    hideClear: Boolean,
  },
  components: {
    FDropdown,
  },
  computed: {
    displayYearOptions() {
      return getProductRateYearList();
    },
  },
};
</script>
